import React, { useState } from 'react';
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, Typography, Button } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import Moment from "moment";

const useStyles = makeStyles({
  cardApp: {
    minWidth: 275,
    borderRadius: "10px",
    boxShadow: "rgb(0 0 0 / 15%) 0px 5px 5px 0px"
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  }
});

const AppCard = (props) => {
  const classes = useStyles();
  const history = useHistory()

  const handleUpdate = (app) => {
    history.push({
      pathname: `/updateApp/${app._id}`,
      state: app
    })
  }

  const [state, setState] = useState({
    checked: true,
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  return (
    <Card className={classes.cardApp} variant="outlined">
      <CardContent>
        {
          props.app.logoUrl?
          <img style={{borderRadius: "50%", width: "100px", height: "100px", objectFit: "cover", border: "2px solid #dadada"}} width="150px" src={props.app.logoUrl} alt="logo quickey beta"/>
          :
          <img style={{borderRadius: "50%", width: "100px", height: "100px", objectFit: "cover", border: "2px solid #dadada"}} width="150px" src="/logo-placeholder.png" alt="logo quickey beta"/>
        }
        <Typography variant="h6" component="h2" className="mt-15">
          {
            props.app.appName
          }
        </Typography>
        <Typography variant="body2" component="p" className="pb-10 pt-10 text-darkgrey reguler">
          {
            props.app.description?
            props.app.description : "-"
          }
        </Typography>
        <Typography variant="body2" component="p" className="text-grey reguler">
          Create Date : &thinsp;
          <span>
            {
              Moment(props.app.createdAt).format("DD/MM/YYYY")
            }
          </span>
        </Typography>
        <Typography variant="body2" component="p" className="text-grey reguler">
          Updated Date : &thinsp;
          <span>
            {
              Moment(props.app.updatedAt).format("DD/MM/YYYY")
            }
          </span>
        </Typography>
        <Typography variant="body2" component="p" className="text-grey reguler mb-10">
          Status : &thinsp;
          <span>
            Enable
          </span>
        </Typography>
        <Switch
          checked={state.checked}
          onChange={handleChange}
          color="primary"
          name="checked"
          inputProps={{ 'aria-label': 'primary checkbox' }}
          size="small"
        />
        <br/>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleUpdate(props.app)}
          className="btn-black mt-10"
          >
          Konfigurasi
        </Button>
      </CardContent>
    </Card>
  );
}

export default AppCard